import styles from "./OrdersWorkspace.module.css";

const STATUS_FAMILIES = Object.freeze({
  Pending: "pending",
  "Verifying Payment": "pending",
  Confirmed: "confirmed",
  Picked: "active",
  "In Progress": "active",
  "Partially Fulfilled": "active",
  Shipped: "transit",
  Delivered: "success",
  Completed: "success",
  Cancelled: "failed",
  "Payment Failed": "failed",
  Returned: "reversed",
  Refunded: "reversed",
});

const OrderStatusBadge = ({ status }) => {
  const family = STATUS_FAMILIES[status] || "neutral";

  return (
    <span className={`${styles.semanticBadge} ${styles[family]}`} data-status-family={family}>
      {status}
    </span>
  );
};

export default OrderStatusBadge;
